<template>
	<div class="page-new-s-inventory">
		<v-layout row justify-space-between>
			<v-flex xs7>
				<tabs :items="items"/>
				<table-question 
					title-question="Preguntas" 
					:questions="rows"
					class="mt-4"
					height="calc(100vh - 370px)"
				/>
			</v-flex>
			<v-flex xs4>
				<question 
					title="Inventario de Cultura Organizacional"
					subTitle="Instructivo">
					<div 
						v-html="text" 
						class="text-presentation"
						slot="question"
					></div>
					<v-btn 
						class="btn btn-action"
						slot="footer"
						@click="openNewSurveys"
						color="primary"
					>Crear Encuesta</v-btn>
				</question>
			</v-flex>
		</v-layout>
		<open-modal
			:dialog="dialog"
			:footer="false"
			@close-modal="closeModal"
		>
			<v-layout justify-space-between>
				<v-flex xs8 pl-5 class="message-error-container">
					<label class="new-survey-label">Nombre de la Encuesta</label>
					<input 
						class="new-survey-input" 
						placeholder="Nombre de la Encuesta"
						:style="`color: ${$appColors.info} !important`"
						v-model="nameSuvery"
					/>
					<span
						v-if="!nameSuvery"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El nombre es requerido
					</span>
				</v-flex>
				<v-flex xs2 pt-4>
					<v-btn
						:disabled="!disabled"
						class="btn btn-action btn-disabled-background" 
						@click="goToList"
						color="primary"
					>
						Finalizar
					</v-btn>
				</v-flex>
			</v-layout>
		</open-modal>
	</div>
</template>
<script>
import tabs from '@/components/surveys/tabs';
import tableQuestion from '@/components/surveys/table-question';
import question from '@/components/organizational/question';
import toolsCode from '@/shared/tools-codes';
import openModal from '@/components/configuration/open-modal';

function created() {
	this.listQuestion();
}

async function listQuestion() {
	const params = {
		level: 3,
		flagLevel: true,
	};
	try {
		const response = await this.$http.get(`/hierarchies/${toolsCode.OrgaCultureInventory}`, { params });
		this.rows = response.data;
	} catch (error) {
		this.showGenericError();
	}
}

function openNewSurveys() {
	this.dialog = true;
}

async function goToList() {
	const newArray = this.rows.map(q => q.id);
	const body = {
		name: this.nameSuvery,
		toolCode: toolsCode.OrgaCultureInventory,
		languages: null,
		factorsWeight: [
			{
				totalQuestions: this.rows.length,
				questions: newArray,
			},
		],
	};
	try {
		const { data: poll } = await this.$http.post('polls', body);
		this.showNotification('La encuesta ha sido creada correctamente.');
		const params = { toolCode: toolsCode.OrgaCultureInventory, pollId: poll.id };
		this.goTo('new-diagnosis', { params });
	} catch (error) {
		this.showGenericError();
	}
}

function disabled() {
	return this.nameSuvery.trim() !== '';
}

function closeModal(val) {
	this.dialog = val;
}

function data() {
	return {
		nameSuvery: '',
		dialog: false,
		items: [
			{
				number: 1,
				name: 'Preguntas',
				step: 1,
				complete: false,
				page: 'new-inventory',
			},
		],
		rows: [],
		text: `<p>La presente herramienta se aplica con el fin de recabar datos y opiniones 
						de los talentos humanos de la organización con el fin de diagnosticar.</p>
						<p>El clima laboral de la organización de la referencia. Es de alta utilidad 
						en planificación, gestión y desarrollo organizacional.</p>	
						<p>Está diseñada para trabajarla con todo tipo de personal administrativo, 
						técnico y directivo; por lo cual se recomienda mínimo un nivel de bachillerato.</p>
						<p>Se recomienda leer todo este instructivo y proceder conforme se sugiere.</p>
						<p>Si necesita mayor información favor dirigirse a: info@godsulting.com.</p>`,
	};
}
export default {
	name: 'new-surveys-inventory',
	data,
	created,
	computed: {
		disabled,
	},
	components: {
		tabs,
		tableQuestion,
		question,
		openModal,
	},
	methods: {
		closeModal,
		goToList,
		listQuestion,
		openNewSurveys,
	},
};
</script>
<style lang="scss">
	.page-new-s-inventory {
		position: relative;

		.v-stepper__header {
			justify-content: center;
		}

		.text-presentation {
			color: color(tooltip-gray);
			font-size: font-size(medium);
			padding: 24px 30px 12px;
			text-align: justify;
		}

		.wrapper-btn {
			align-items: center;
			background: map-get($colors, white);
			border-top: 1px solid map-get($colors, gray-slider);
			bottom: 0;
			display: flex;
			height: 72px;
			justify-content: center;
			left: 0;
			margin-left: 70px;
			position: fixed;
			right: 0;
		}
	}

	.new-survey-label {
		color: color(tooltip-gray);
	}

	.message-error-container {
		position: relative;
	}

	.message-error {
		bottom: -15px;
		font-family: font(regular);
		font-size: size(small11);
		position: absolute;
		width: 100%;
	}
</style>





// WEBPACK FOOTER //
// src/pages/inventory/page-new-surveys-inventory.vue